import NextLink from "next/link";

import { useTranslator } from "@eo-locale/react";

import some from "lodash/some";

import { sanitizeHref } from "@/lib";
import { useAppSelector } from "@/redux/store/hooks";
import {
  Footer,
  FooterLink,
  FooterLinks,
  FooterLogo,
  FooterSocialMediaLinks,
  Image
} from "@/storybook-components";
import LiquidTemplateFooter from "../liquid-templates/footer";

import { addAssetPrefix } from "@/helpers/add-asset-prefix";

const EHQFooter = (): JSX.Element => {
  const { translate } = useTranslator();
  const { liquidTemplates } = useAppSelector((state) => state.liquidTemplates);
  const { footerLinks } = useAppSelector((state) => state.navigationLinks);
  const { homePageRevision } = useAppSelector(
    (state) => state.homePageRevision
  );
  // as footerLinks is immutable
  const footerArray = [...footerLinks];

  const { data, theme } =
    homePageRevision?.sections?.sections?.slice(-1)[0] || {};
  const {
    facebookUrl,
    twitterUrl,
    googleUrl,
    linkedinUrl,
    instagramUrl,
    youtubeUrl
  } = (Array.isArray(data) && data.length > 0 ? data[0] : {}) as {
    facebookUrl: string;
    twitterUrl: string;
    googleUrl: string;
    linkedinUrl: string;
    instagramUrl: string;
    youtubeUrl: string;
  };

  const node = some(
    liquidTemplates,
    (template) => template.path === "liquid_templates/footer" && template.body
  );

  return (
    <footer>
      <Footer
        color={theme?.textColor}
        className="ehq-participant-footer"
        background={theme?.backgroundColor}
        position={node ? "absolute" : "static"}
      >
        <FooterSocialMediaLinks
          facebookUrl={facebookUrl}
          twitterUrl={twitterUrl}
          googleUrl={googleUrl}
          linkedinUrl={linkedinUrl}
          instagramUrl={instagramUrl}
          youtubeUrl={youtubeUrl}
          className="ehq-participant-footer__social-links"
        />
        <FooterLinks className="ehq-participant-footer__static-pages">
          {footerArray
            .sort((a, b) => a.sequence - b.sequence)
            .map(({ id, title, linkableUrl }) => (
              <FooterLink key={id}>
                <NextLink
                  href={sanitizeHref(linkableUrl)}
                  passHref
                  style={{
                    color: "inherit",
                    textDecoration: "inherit"
                  }}
                >
                  {title}
                </NextLink>
              </FooterLink>
            ))}
        </FooterLinks>
        <FooterLogo className="ehq-participant-footer__logo">
          <Image
            htmlHeight="35px"
            htmlWidth="150px"
            src={addAssetPrefix("/images/granicus-logo.png")}
            alt={translate("common.poweredByEnagamentHQ")}
          />
        </FooterLogo>
      </Footer>
      <LiquidTemplateFooter />
    </footer>
  );
};

export default EHQFooter;
